import { render, staticRenderFns } from "./GenerarFacturasPage.vue?vue&type=template&id=16c28bee&scoped=true"
import script from "./GenerarFacturasPage.vue?vue&type=script&lang=js"
export * from "./GenerarFacturasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c28bee",
  null
  
)

export default component.exports